export enum EJobStatuses {
  "FOR_REVISION" = "forRevision",
  "APPROVED" = "approved",
  "CANCELLED" = "cancelled",
  "SUPPORT" = "support",
  "SCHEDULED" = "scheduled",
  "IN_PROGRESS" = "inProgress",
  "COMPLETED" = "completed",
}